var PeriodEnum;
(function (PeriodEnum) {
    PeriodEnum["day"] = "DAY";
    PeriodEnum["week"] = "WEEK";
    PeriodEnum["month"] = "MONTH";
    PeriodEnum["twoMonth"] = "TWOMONTH";
    PeriodEnum["year"] = "YEAR";
    PeriodEnum["max"] = "MAX";
})(PeriodEnum || (PeriodEnum = {}));
var ChartType;
(function (ChartType) {
    ChartType["simple"] = "simple";
    ChartType["candlesticks"] = "candlesticks";
    ChartType["histogram"] = "histogram";
})(ChartType || (ChartType = {}));

export { ChartType, PeriodEnum };
//# sourceMappingURL=tradingViewSimpleChart.props.js.map
